import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import OCRBulkProgressModalViewModel from './OCRBulkProgressModalViewModel'
import ModalRadialProgression from '../ModalRadialProgression'

/**
 * Confirm Bulk Submit Modal
 */
export default observer(function OCRBulkProgressModal({
  vm,
}: {
  vm: OCRBulkProgressModalViewModel
}) {
  const hasBulkActionErrors =
    !vm.ocrScopingJobBulkActionViewModel.isProcessing &&
    vm.ocrScopingJobBulkActionViewModel.hasBulkActionErrors
  return (
    <ModalSheet showing={vm.showing} disableCloseOnOutsideClick>
      <ModalSheetHeader />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalRadialProgression
            progress={vm.ocrScopingJobBulkActionViewModel.progress}
            completed={
              vm.ocrScopingJobBulkActionViewModel.bulkActionCompletedCount
            }
            total={vm.ocrScopingJobBulkActionViewModel.bulkActionSelectedCount}
            withError={hasBulkActionErrors}
          />
        </ModalSheetContentBlock>
        {vm.ocrScopingJobBulkActionViewModel.isProcessing ? (
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              The jobs are being processed
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              If you close this window, the remaining jobs will not get
              processed.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        ) : vm.ocrScopingJobBulkActionViewModel.hasBulkActionErrors ? (
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              The process has{' '}
              {vm.ocrScopingJobBulkActionViewModel.bulkProcessWasCancelled
                ? 'been cancelled and '
                : ''}
              finished with errors
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              A total of{' '}
              {
                vm.ocrScopingJobBulkActionViewModel
                  .bulkActionCompletedSuccessfully
              }{' '}
              jobs were successfully processed, and{' '}
              {vm.ocrScopingJobBulkActionViewModel.bulkActionErrors.length}{' '}
              failed with errors.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        ) : (
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              The process has
              {vm.ocrScopingJobBulkActionViewModel.bulkProcessWasCancelled
                ? ' been cancelled'
                : ' finished processing'}
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              A total of{' '}
              {
                vm.ocrScopingJobBulkActionViewModel
                  .bulkActionCompletedSuccessfully
              }{' '}
              jobs were successfully processed.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        )}
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          {vm.ocrScopingJobBulkActionViewModel.bulkProcess.pending ? (
            <Button onClick={vm.cancel}>Cancel</Button>
          ) : (
            <Button onClick={vm.close}>Close</Button>
          )}
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
